import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
} from "@mui/material";

const Section = ({ title, items }) => (
  <Box mb={4}>
    <Typography variant="h5" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <List>
      {items.map((item, index) => (
        <ListItem key={index} alignItems="flex-start">
          <ListItemText primary={`${String.fromCharCode(97 + index)}. ${item}`} />
        </ListItem>
      ))}
    </List>
  </Box>
);

const TermsPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Terms and Conditions
        </Typography>

        <Typography variant="body1" paragraph>
          The following are the terms and conditions that León Gallery has set
          for the auction. Kindly read carefully.
        </Typography>

        <Typography variant="body1" paragraph>
          León Gallery, all the participants of the event, processes, and
          transactions shall be guided accordingly by these rules:
        </Typography>

        <Divider sx={{ my: 3 }} />

        
        <Section
          title="GENERAL"
          items={[
            "Each item (lot) in this catalog is offered for sale dependent on the terms exhibited below.",
            "All lots are numbered according to the catalog unless otherwise stated by the auctioneer.",
            "Transferring, selling, assigning of lots to anyone other than the bidder that won prior to removal is not allowed.",
            "All items sold do not have any warranty. León Gallery is not liable for any circumstances after transfer.",
            "All participants must agree to be bound by these terms.",
          ]}
        />

        
        <Section
          title="BIDDING"
          items={[
            "Bidders must complete registration and present valid government-issued ID.",
            "Each buyer will be given a buyer’s number. Highest bidder wins the lot.",
            "Failure to object to winning announcement is considered acknowledgment.",
            "Buyer’s premium is 18% plus VAT (20.16% total).",
            "Auctioneer supervises bidding and resolves disputes.",
            "León Gallery may withdraw items or reject bids anytime.",
            "Absentee bids are allowed up to 15 minutes before auction.",
            "Tie bids: earlier bid wins. León Gallery not liable for failed absentee bids.",
          ]}
        />

        
        <Section
          title="PAYMENT"
          items={[
            "Full payment and pickup must be completed within 3 days.",
            "Storage fee: Php 500 per lot per day beyond 3 days.",
            "Items left beyond 4 weeks are considered abandoned.",
            "Packing/shipping is at buyer’s risk.",
            "Accepted payments: cash, check, wire transfer.",
            "Legal enforcement allows recovery of attorney’s fees.",
          ]}
        />

        <Box mb={4}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Bank Details
          </Typography>
          <Typography variant="body2">
            Account Name: LEON ART GALLERY <br />
            Account Type: PESO ACCOUNT <br />
            Account No: 166-7-166-52009-2 <br />
            Bank: METROBANK - CORINTHIAN PLAZA BRANCH <br />
            Swift Code: MBTCPHMM <br />
            Address: G/F Corinthian Plaza Bldg., Paseo de Roxas, Makati City
          </Typography>
        </Box>

        
        <Section
          title="LITIGATION"
          items={[
            "All disputes shall be submitted to the Law Courts of Makati.",
          ]}
        />
      </Paper>
    </Container>
  );
};

export default TermsPage;